export const articleUrl = (a) => (a ? `/${a.category_slug}/${a.slug}/` : "/");
export const categoryUrl = (slug) => `/${slug}/`;

export function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export const cx = (...c) => c.filter(Boolean).join(" ");

export const CONTENT_TYPE_LABEL = {
  article: "Article", guide: "Guide", comparison: "Comparison", "best-time-to-buy": "Best Time to Buy",
  "how-to": "How-To", listicle: "List", "free-alternative": "Free Alternative", tip: "Tip",
};
